import type {
  OrderTracking,
  Path,
  SupplierLocate,
} from '@ahm/api-wrappers-core';
import { vanillaMapStore } from '@ahm/react-map/store';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from './selectors';

export type PowData = {
  pow_info?: string | string[];
  path: Path;
};

export interface TrackingState {
  currentOrder: OrderTracking | null;
  supplierLocate: SupplierLocate | null;
  powData: PowData | null;
}

export interface TrackingActions {
  setCurrentOrder: (order: OrderTracking | null) => void;
  setSupplierLocate: (supplierLocate: SupplierLocate | null) => void;
  setPowData: (data: PowData) => void;
  clearPowData: () => void;
}

const store = create<
  TrackingState & TrackingActions,
  [
    ['zustand/devtools', TrackingState & TrackingActions],
    ['zustand/persist', Pick<TrackingState, 'currentOrder'>],
  ]
>(
  devtools(
    // persist(
    (set) => {
      return {
        currentOrder: null,
        supplierLocate: null,
        powData: null,
        setCurrentOrder: (order) => {
          set({ currentOrder: order });
        },
        setSupplierLocate: (supplierLocate) => {
          set({ supplierLocate });
        },
        setPowData: (powData) => {
          set({ powData });
        },
        clearPowData: () => {
          set({ powData: null });
        },
      };
    }
    // { name: 'tracking', skipHydration: true },
    // ),
  )
);

export const useTrackingControl = createSelectors(store);

useTrackingControl.subscribe((state) => {
  const setCenterCoords = vanillaMapStore.getState().setCenterCoords;
  if (state.currentOrder) {
    const pickupPoint: Path | null = state.currentOrder.path
      ? state.currentOrder.path[0]
      : null;
    if (pickupPoint?.lat && pickupPoint.lng) {
      setCenterCoords({
        latitude: pickupPoint.lat,
        longitude: pickupPoint.lng,
      });
    }
  } else {
    setCenterCoords(null);
  }
});
